<div mat-dialog-content>
        <p>Sei sicuro di voler cancellare <strong>{{name}}</strong>?</p>
</div>
